import { render } from "./RegionDatatable.vue?vue&type=template&id=090c733c"
import script from "./RegionDatatable.vue?vue&type=script&lang=js"
export * from "./RegionDatatable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__